module.exports = __webpack_public_path__ + "img/chess-bishop.18577141.svg";